export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '28515d60-6c5c-4ae0-91be-1799fdc3e0a7';
export const MODAL_CLOSE_SEC = 2.5;
